import { createAsyncThunk } from "@reduxjs/toolkit";
// import { ColumnFiltersState } from "@tanstack/react-table";
import { Axios } from "api/axios";
// import axios from "axios";
import { handleApiError } from "utils/errorHandling";

export const fetchItems = createAsyncThunk(
  "item/fetchItems",
  async ({
    page,
    pageSize,
    sort,
    order,
    search,
    filters,
  }: {
    page: number;
    pageSize: number;
    search?: string;
    sort?: string;
    order?: "asc" | "desc" | "";
    filters?: any;
  }) => {
    const params = new URLSearchParams();
    params.append("page", page.toString());
    params.append("page_size", pageSize.toString());
    if (search) params.append("search", search);
    if (sort) {
      const orderingValue = order === "desc" ? `-${sort}` : sort;
      params.append("ordering", orderingValue);
    }
    console.log("sort : ", sort);
    console.log("order : ", order);



    if (filters && filters.length > 0) {
      filters.forEach(
        ({
          filterField,
          filterValue,
        }: {
          filterField: string;
          filterValue: any;
        }) => {
          if (!filterField || filterValue === undefined || filterValue === null) return;

          // If filterValue is an object (like from_date/to_date)
          if (typeof filterValue === "object" && filterValue !== null) {
            if (filterValue.from_date)
              params.append(`${filterField}_date_from`, filterValue.from_date);
            if (filterValue.to_date)
              params.append(`${filterField}_date_to`, filterValue.to_date);
          } else {
            // Primitive value
            params.append(filterField, String(filterValue));
          }
        }
      );
    }

    // console.log(`api/item/?${params.toString()}`)
    const response: any = await Axios.get(`api/item/?${params.toString()}`);
    // console.log("itemResponse : ", filters);
    // const response: any = await Axios.get(`/item/`, {
    //   params: {
    //     page,
    //     page_size: pageSize,
    //     search: search || undefined,
    //     filters: filters ? JSON.stringify(filters) : undefined,
    //   },
    // });

    // console.log("thunk", response)
    return {
      data: response?.data?.data || [],
      rowCount:
        (response?.data && (response?.data?.count ?? response?.data?.total)) ||
        0,
    };
  }
);

export const fetchItemById = createAsyncThunk(
  "item/fetchById",
  async (id: string, { rejectWithValue }) => {
    try {
      const response: any = await Axios.get(`/api/item/view-details/${id}/`);
      return response?.data?.data ?? response?.data ?? response;
    } catch (err: any) {
      const error = handleApiError(err);
      return rejectWithValue(error);
    }
  }
);

export const fetchItemByDropDown = createAsyncThunk(
  "Item/fetchByDropDown",
  async (_, { rejectWithValue }) => {
    try {
      const response = await Axios.get(`/Item/dropdown/`);
      return response.data;
    } catch (err: any) {
      return rejectWithValue(err.response?.data || "Failed to fetch Item list");
    }
  }
);

export const updateItem = createAsyncThunk(
  "item/updateItem",
  async (
    { id, formData }: { id: string; formData: FormData },
    { rejectWithValue }
  ) => {
    try {
      const token = JSON.parse(localStorage.getItem("authUser") || "{}")?.access;

      const response = await Axios.put(
        `api/item/edit/${id}/`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      return response.data; // ✅ success
    } catch (err: any) {
      const error = handleApiError(err);
      return rejectWithValue(error);
    }
  }
);


export const updateStatusInItem = createAsyncThunk(
  "item/updateStatusInItem",
  async (itemId: any, { rejectWithValue }) => {
    try {
      // const payload = { is_active: itemData.is_active };
      const response: any = await Axios.patch(
        `/api/item/edit-status/${itemId}/`,
      );

      return response.data.data;
    } catch (err: any) {
      return rejectWithValue(err.response?.data || "Failed to update GP");
    }
  }
);


export const addItem = createAsyncThunk(
  "item/addItem",
  async (formData: FormData, { rejectWithValue }) => {
    try {
      const token = JSON.parse(localStorage.getItem("authUser") || "{}")?.access;

      const response = await Axios.post(
        `api/item/create/`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data"
          },
        }
      );

      console.log(response)

      return response.data; // ✅ success
    } catch (err: any) {
      console.log(err)
      const error = err.response?.data || "Failed to add item";
      return rejectWithValue(error);
    }
  }
);





//Exports csv file
// Exports department CSV file
export const exportItemCSV = createAsyncThunk(
  "item/exportItemCSV",
  async (_, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("authToken");
      const headers = {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        Accept: "*/*",
      };
      // Use responseType: 'blob' to get the file as a blob
      const response = await Axios.get("item/?export=csv", {
        headers,
        responseType: "blob",
      });
      // Return the blob and filename (if any)
      return {
        blob: response.data,
        filename:
          response.headers["content-disposition"]
            ?.split("filename=")[1]
            ?.replace(/"/g, "") || "item.csv",
      };
    } catch (err: any) {
      console.error("Export CSV error:", err);
      return rejectWithValue(err.message || "Failed to export CSV");
    }
  }
);

export const exportItemCSV_v2 = async ({
  search,
  filters,
}: {
  search?: string;
  filters?: any;
}) => {
  const params = new URLSearchParams();

  params.append("export", "excel");

  if (search) params.append("search", search);

  if (filters && filters.length > 0) {
    filters.forEach(
      ({
        filterField,
        filterValue,
      }: {
        filterField: string;
        filterValue: any;
      }) => {
        if (filterField && filterValue !== undefined && filterValue !== null) {
          if (typeof filterValue === "object" && filterValue !== null) {
            Object.entries(filterValue).forEach(([key, value]) => {
              if (value !== undefined && value !== null && value !== "") {
                params.append(key, String(value));
              }
              if (
                (filterValue.from_date || filterValue.to_date) &&
                (filterField === "created_at" || filterField === "updated_at")
              ) {
                if (filterField === "created_at") {
                  filterField = "created";
                } else {
                  filterField = "updated";
                }
                params.append("filter_by", filterField);
              }
            });
          } else {
            params.append(filterField, filterValue);
          }
        }
      }
    );
  }

  const response = await Axios.get(`/item/?${params.toString()}`, {
    responseType: "blob",
  });

  return {
    blob: response.data,
    filename:
      response.headers["content-disposition"]
        ?.split("filename=")[1]
        ?.replace(/"/g, "") || "item.csv",
  };
};


//*// Current Export 
export const exportItemCSV_v3 = async ({
  search,
  filters,
}: {
  search?: string;
  filters?: any;
}) => {
  const params = new URLSearchParams();

  params.append("export", "excel");

  if (search) params.append("search", search);

  if (filters && filters.length > 0) {
    filters.forEach(
      ({
        filterField,
        filterValue,
      }: {
        filterField: string;
        filterValue: any;
      }) => {
        if (!filterField || filterValue === undefined || filterValue === null) return;

        // If filterValue is an object (like from_date/to_date)
        if (typeof filterValue === "object" && filterValue !== null) {
          if (filterValue.from_date)
            params.append(`${filterField}_date_from`, filterValue.from_date);
          if (filterValue.to_date)
            params.append(`${filterField}_date_to`, filterValue.to_date);
        } else {
          // Primitive value
          params.append(filterField, String(filterValue));
        }
      }
    );
  }

  // Step 1: First call – get the file_url
  const response = await Axios.get(`/api/item/export-to-excel/?${params.toString()}`);

  const fileUrl = response.data?.file_url;
  if (!fileUrl) {
    throw new Error("No file_url found in API response");
  }

  // Step 2: Second call – download the file as blob
  const downloadResponse = await Axios.get(fileUrl, {
    responseType: "blob",
  });

  // Step 3: Get filename from file_url
  const filename = fileUrl.split("/").pop() || "item.xlsx";

  return {
    blob: downloadResponse.data,
    filename,
  };
};


export const deleteItemById = createAsyncThunk(
  "item/deleteItemById",
  async (id: string, { rejectWithValue }) => {
    try {
      const response: any = await Axios.delete(`/api/item/delete/${id}/`);
      if (response?.data?.success) {
        return { id }; // return the deleted item's id
      }
      return rejectWithValue("Failed to delete item");
    } catch (err: any) {
      return rejectWithValue(err.response?.data || "Failed to delete item");
    }
  }
);



//*// Latest Item Fetch for Template
export const fetchLatestItemById = createAsyncThunk(
  "item/fetchLatestItemById",
  async (id: string, { rejectWithValue }) => {
    try {
      const response: any = await Axios.get(`/api/item/view-details/${id}/`);
      return response?.data?.data ?? response?.data ?? response;
    } catch (err: any) {
      return rejectWithValue(err.response?.data || "Failed to fetch Item by ID");
    }
  }
);




export const fetchAllItemSyncLogs = createAsyncThunk(
  "item/fetchAllItemSyncLogs",
  async (
    {
      page,
      pageSize,
      sort,
      order,
      search,
      filters,
    }: {
      page: number;
      pageSize: number;
      search?: string;
      sort?: string;
      order?: "asc" | "desc" | "";
      filters?: any;
    },
    { rejectWithValue }
  ) => {
    try {
      const params = new URLSearchParams();
      params.append("page", page.toString());
      params.append("page_size", pageSize.toString());
      if (search) params.append("search", search);
      if (sort) {
        const orderingValue = order === "desc" ? `-${sort}` : sort;
        params.append("ordering", orderingValue);
      }
      // console.log("sort : ", sort);
      // console.log("order : ", order);

      if (filters && filters.length > 0) {
        filters.forEach(
          ({
            filterField,
            filterValue,
          }: {
            filterField: string;
            filterValue: any;
          }) => {
            if (!filterField || filterValue === undefined || filterValue === null) return;

            // If filterValue is an object (like from_date/to_date)
            if (typeof filterValue === "object" && filterValue !== null) {
              if (filterValue.from_date)
                params.append(`${filterField}_date_from`, filterValue.from_date);
              if (filterValue.to_date)
                params.append(`${filterField}_date_to`, filterValue.to_date);
            } else {
              // Primitive value
              params.append(filterField, String(filterValue));
            }
          }
        );
      }

      const response: any = await Axios.get(
        `api/item/item-sync-logs/?${params.toString()}`
      );

      return {
        data: response?.data?.data || [],
        rowCount:
          (response?.data && (response?.data?.count ?? response?.data?.total)) ||
          0,
      };
    } catch (err: any) {
      // Attach error message or response if available
      return rejectWithValue(
        err.response?.data?.detail ||
        err.response?.data ||
        err.message ||
        "Failed to fetch item sync logs"
      );
    }
  }
);